import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
`;

export const Divisor = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  div.double {
    width: 48% !important;
  }

  .new-company {
    margin-top: 5px;
    border: none;
    background: none;
    text-decoration: underline;
    color: #0074b8;
    margin-top: 15px;
  }
`;
